import { useEffect, useState } from 'react';
import { IFlow } from '../Components/Calculations/Conditions/Evaluation/EvaluationInterface';
import { IRelativeCondition } from '../Components/DataSet/types/BottomBarInterfaces';
import { fetchDateRangeFromRelativeRange } from '../api/filters';

export const useRelaiveFilter = (
  connectionId: string,
  dsId: string,
  workspaceId: string,
  calculationDetails: IFlow | null,
  relativeConDition: IRelativeCondition,
  tableId?: string,
  fieldName?: string,
  isFlow = false,
  dataType?: string,
) => {
  const [data, setData] = useState<{ from: string; to: string }>({ from: '', to: '' });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );
  useEffect(() => {
    if ((!connectionId && !dsId) || !workspaceId) {
      setError({ message: 'Content not found', code: 400, isError: true });
      setLoading(false);
      return;
    }

    async function fetchData() {
      if (!tableId || !fieldName || !dataType) {
        setError({ message: 'Column details are not found', code: 400, isError: true });
        setLoading(false);
        return;
      } else if (isFlow && !calculationDetails) {
        setError({ message: 'Flow details are not found', code: 400, isError: true });
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        let payload = {
          filterTable: {
            tableId: tableId,
            fieldName: fieldName,
            dataType: dataType,
            filterOption: 'allValues',
            ...(isFlow
              ? {
                  isCalculatedField: true,
                  calculatedField: [
                    {
                      calculatedFieldName: calculationDetails!.calculatedFieldName,
                      fields: calculationDetails!.fields,
                      flows: calculationDetails!.flows,
                      conditionFilters: calculationDetails!.conditionFilters,
                    },
                  ],
                }
              : {}),
          },
          from: relativeConDition.from,
          to: relativeConDition.to,
          anchorDate: relativeConDition.anchorDate,
        };
        const res = await fetchDateRangeFromRelativeRange(connectionId, dsId, workspaceId, payload);
        if (res.isError) {
          setError({ message: res.message, code: 400, isError: true });
          setLoading(false);
          return;
        }
        setData(res.data!);
        setLoading(false);
        setError(null);
      } catch (error) {
        setError({
          message: (error as any).message ?? 'Error while fetching the data',
          code: (error as any).code || 500,
          isError: true,
        });
        setLoading(false);
      }
    }
    fetchData();
  }, [
    isFlow,
    tableId,
    fieldName,
    connectionId,
    dsId,
    workspaceId,
    calculationDetails,
    relativeConDition,
    dataType,
  ]);

  return {
    result: data,
    loading,
    error,
  };
};
